import axios from "@/utils/axios";

const getAllClientes = async (filters) => {
  let result = null;
  try {
    result = (await axios.post("/clientes/getAll", filters)).data;
  } catch (error) {
    console.log("error on getAllClientes", error);
  }
  return result;
};

const buscaPorTelefone = async (telefone) => {
  let result = null;
  try {
    result = (
      await axios.post("/clientes/buscarPorTel", {
        telefone: telefone
          .trim()
          .replace(" ", "")
          .replace("-", "")
          .match(/\d+/g)
          .join(""),
      })
    ).data;
  } catch (error) {
    console.log("error on buscaPorTelefone", error);
  }
  return result;
};

const salvarCliente = async(data)=>{
  try {
    return (await axios.post("/clientes/store", data)).data;
  }
  catch(err){
    console.log("error on salvarCliente", err);
  }
}

const previewUnificacao = async ({ cod_cliente_destino, cod_cliente_origens }) => {
  try {
    return (await axios.post("/clientes/previewUnificacao", { cod_cliente_destino, cod_cliente_origens })).data;
  } catch (err) {
    console.log("error on previewUnificacao", err);
    return { success: false, message: (err && err.message) || "Erro ao consultar prévia" };
  }
}

const unificar = async ({ cod_cliente_destino, cod_cliente_origens }) => {
  try {
    return (await axios.post("/clientes/unificar", { cod_cliente_destino, cod_cliente_origens })).data;
  } catch (err) {
    console.log("error on unificar", err);
    return { success: false, message: (err && err.response && err.response.data && err.response.data.message) || (err && err.message) || "Erro ao unificar" };
  }
}

export default {
  getAllClientes,
  buscaPorTelefone,
  salvarCliente,
  previewUnificacao,
  unificar
};
